<h1 class="titulo-principal">¡Así de fácil! Revisa los detalles de contratación y confirma</h1>
<mat-accordion multi="true">
    <ng-container *ngIf="isPersonaNatural; else personaJuridica">
        <app-datos-entrega></app-datos-entrega>
        <app-cuotas-tbk></app-cuotas-tbk>
        <app-abonos></app-abonos>
        <app-firmar-documentos></app-firmar-documentos>
        <app-terminos-condiciones></app-terminos-condiciones>
    </ng-container>
    <ng-template #personaJuridica>
        <app-datos-entrega></app-datos-entrega>
        <app-cuotas-tbk></app-cuotas-tbk>
        <app-abonos-pj></app-abonos-pj>
        <app-firmar-documentos></app-firmar-documentos>
        <app-terminos-condiciones></app-terminos-condiciones>
    </ng-template>
</mat-accordion>